import { render, staticRenderFns } from "./export-data.vue?vue&type=template&id=8bc82738"
import script from "./export-data.vue?vue&type=script&lang=js"
export * from "./export-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports